import { StrategyType } from "../../utils/enums";

const initialState = () => ({
  strategyTypes: [
    { id: StrategyType.predictive, name: "Predictivo" },
    { id: StrategyType.progressive, name: "Progresivo" },
    { id: StrategyType.sms, name: "SMS" },
    { id: StrategyType.ivr, name: "IVR" },
    { id: StrategyType.ivrReturn, name: "IVR con retorno" },
    { id: StrategyType.whatsapp, name: "WhatsApp" },
    { id: StrategyType.email, name: "Correo Masivo" },
  ],
});

const state = initialState();

export default state;
